let mobile = false;

export function getIsMobile() {
  return mobile;
}

export function setIsMobile(isMobile: boolean) {
  mobile = isMobile;
}
